import { MrbBaseViewStore } from "mrb/core/stores";
import { action, computed, makeObservable } from "mobx";
import { MrbSelectStore } from "mrb/components/select";
import { UUID } from "common/utils";
import { find, findIndex, isNil, isEmpty, filter } from "lodash";

class LoadioStoreHomeSectionViewStore extends MrbBaseViewStore {
    @computed get item() {
        return find(this.loadioStoreHomeSectionListViewStore.sections, (section) => section.id === this.id);
    }

    @computed get isAddContentButtonDisabled() {
        return isNil(this.contentSelectStore.selectedItem) || !this.item.isActive || this.selectedItemExists;
    }

    @computed get isSystemSection() {
        return !isEmpty(this.item.systemSectionIdentifier);
    }

    @computed get selectedItemExists() {
        const selectedItem = this.contentSelectStore.selectedItem;
        if (!selectedItem) {
            return false;
        }

        return (
            findIndex(
                this.item.items,
                (x) =>
                    /* eslint-disable eqeqeq */
                    x.loadioArtistId == selectedItem.loadioArtistId && x.loadioAlbumId == selectedItem.loadioAlbumId
            ) !== -1
        );
    }

    constructor(rootStore, { loadioStoreHomeSectionListViewStore, id }) {
        super(rootStore);
        this.loadioStoreHomeSectionListViewStore = loadioStoreHomeSectionListViewStore;
        this.routeStore = this.loadioStoreHomeSectionListViewStore.routeStore;
        this.id = id;
        makeObservable(this);

        this.contentSelectStore = new MrbSelectStore({
            isSearchable: true,
            textKey: "title",
            valueKey: "id",
            initFetch: false,
            actions: {
                find: (searchTerm, pageNumber, pageSize) => {
                    return this.routeStore.getContent({
                        search: searchTerm,
                        pageNumber: pageNumber,
                        pageSize: pageSize,
                    });
                },
                mapItem: (item) => {
                    return {
                        label: item.title,
                        value: item.loadioArtistId || item.loadioAlbumId,
                        item: item,
                    };
                },
            },
        });
    }

    @action.bound
    setIsActive(value) {
        this.loadioStoreHomeSectionListViewStore.toggleIsActive(this.id, value);
    }

    @action.bound
    onTitleChange(event) {
        this.item.title = event.target.value;
    }

    addItem(item) {
        this.item.items.push(item);
    }

    @action.bound
    onSelectItem() {
        const item = this.contentSelectStore.selectedItem;
        const obj = {
            id: UUID.create(),
            sortOrder: this.item.items.length,
        };
        if (!isNil(item.loadioArtistId)) {
            obj.loadioArtistId = item.loadioArtistId;
            obj.loadioArtist = {
                id: item.loadioArtistId,
                name: item.title,
                coverImageId: item.coverImageId,
            };
        } else if (!isNil(item.loadioAlbumId)) {
            obj.loadioAlbumId = item.loadioAlbumId;
            obj.loadioAlbum = {
                id: item.loadioAlbumId,
                title: item.title,
                coverImageId: item.coverImageId,
            };
        }
        if (this.itemExists(obj)) {
            return;
        }
        this.addItem(obj);
        this.contentSelectStore.clearOptions();
        this.contentSelectStore.clear();
        this.contentSelectStore.filter();
    }

    itemExists(item) {
        if (!item) {
            return false;
        }
        return (
            findIndex(
                this.item.items,
                (x) =>
                    /* eslint-disable eqeqeq */
                    x.loadioArtistId == item.loadioArtistId && x.loadioAlbumId == item.loadioAlbumId
            ) !== -1
        );
    }

    @action.bound
    deleteSection() {
        this.loadioStoreHomeSectionListViewStore.deleteSection(this.id);
    }

    @action.bound
    deleteItem(id) {
        this.item.items = filter(this.item.items, (item) => item.id !== id);
    }
}

export default LoadioStoreHomeSectionViewStore;
